<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4h360G/tc-custom/9781488083600.jpg?1701060646068" alt="This image is the cover for the book Italian's One-Night Consequence, One Night With Consequences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Italian's One-Night Consequence, One Night With Consequences
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Between the billionaire’s sheets…</i></b><br/><br/><b>Bound by a shocking consequence!</b><br/><br/>Leo Conti is determined to secure a crucial business acquisition—until he meets Maddie Gallo. When their irresistible chemistry ignites, it’s unforgettable! Then Leo learns the truth: Maddie is heiress to the company he plans to take over—and she’s <i>pregnant</i>! Now it’s his heir that must be secured. Can Leo strike a deal to meet Maddie at the altar?<br/><br/><b>“An utterly enjoyable enemy to lovers story…the chemistry between this couple is charming.” </b><i>—Harlequin Junkie </i>on<i> Legacy of His Revenge </i><br/><br/><b>“I absolutely adored this story. The writing was descriptive without being over the top and the characters were in typical Harlequin fashion, perfect. A great read!” </b><i>—Goodreads Reader </i>on<i> Cipriani’s Innocent Captive</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cathy Williams
      </h2>
      
      <p class="authorDescription body article">Cathy Williams is a great believer in the power of perseverance as she had never written anything before her writing career, and from the starting point of zero has now fulfilled her ambition to pursue this most enjoyable of careers. She would encourage any would-be writer to have faith and go for it! She derives inspiration from the tropical island of Trinidad and from the peaceful countryside of middle England. Cathy lives in Warwickshire her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7688df92